import { VALIDATION_MESSAGES } from "utils/constants";
import * as Yup from "yup";

export const ValidationSchema = Yup.object({
  name: Yup.string().required(VALIDATION_MESSAGES.SERVICE_TYPES.NAME.REQUIRED),
  description: Yup.string().required(VALIDATION_MESSAGES.SERVICE_TYPES.DESCRIPTION.REQUIRED),
});
